var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeolocauxExtendWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 518.1 90.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#abd132;}.cls-2{fill:#fff;}.cls-3{fill:#17243d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "geolocaux-extend-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.59,83.57a44.83,44.83,0,0,0,13.93,6V46.66H20.59Zm2-32.73h10v.87h-10Zm0,5.91h10v.87h-10Zm0,5.91h10v.87h-10Zm0,6.16h10v.87h-10Zm0,6.17h10v.87h-10Zm10,6.16V82h-10v-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.85,41.79.17,49.34C1.17,62.19,8,73.53,17.54,81.08V38.31ZM4.21,50.84h10v.87h-10ZM5,56.75l9.27-.08v.86l-9.28.09Zm1.49,5.91,7.79.08v.87l-7.79-.08Zm7.79,7H8.66v-.87h5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45,15.54A29.37,29.37,0,0,1,67.44,26l13.1-8.5A44.94,44.94,0,0,0,0,44.95v.54L17.61,34.07A29.42,29.42,0,0,1,45,15.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.18,37.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.21,
    y: 50.84,
    width: 10.02,
    height: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.08,
    y: 56.5,
    width: 9.27,
    height: 0.87,
    transform: "translate(-0.57 0.1) rotate(-0.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.89,
    y: 59.23,
    width: 0.87,
    height: 7.79,
    transform: "translate(-52.91 72.75) rotate(-89.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.66,
    y: 68.82,
    width: 5.56,
    height: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 50.84,
    width: 10.02,
    height: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 56.75,
    width: 10.02,
    height: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 62.66,
    width: 10.02,
    height: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 68.82,
    width: 10.02,
    height: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 74.99,
    width: 10.02,
    height: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 81.15,
    width: 10.02,
    height: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.19,37.67H55.06l-7.31,7.66,7.31,7.75H73.49A29.42,29.42,0,0,1,37.71,74.31l-.37-.1V90.16a45.79,45.79,0,0,0,7.64.65,45,45,0,0,0,45-45A45.58,45.58,0,0,0,89.19,37.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.69,65.92h-39a12.25,12.25,0,0,0,4.37,9.38,13.24,13.24,0,0,0,9.29,3.55q9.9,0,15.22-7.51l10.74,6.26q-8.44,12.93-26,12.93-12.53,0-19.92-7.93Q97.29,75,97.3,62.89T104.54,43q7.26-7.77,19.77-7.77Q149.69,35.26,149.69,65.92Zm-39-9.81h25.65c0-2-.94-4.1-2.82-6.25a11.47,11.47,0,0,0-9.17-4.17,13.74,13.74,0,0,0-9,3,13.21,13.21,0,0,0-4.66,7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.33,35.26q12.51,0,19.92,7.92,7.08,7.62,7.09,19.71T202.25,82.6q-7.41,7.94-19.92,7.93T162.44,82.6q-7.1-7.6-7.09-19.71T162.6,43Q169.82,35.26,182.33,35.26Zm0,11.68a12.17,12.17,0,0,0-10.22,4.9,19.48,19.48,0,0,0,0,22.11,13.11,13.11,0,0,0,20.44,0,19.48,19.48,0,0,0,0-22.11A12.19,12.19,0,0,0,182.33,46.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.51,89.28V15h12.73V89.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.44,35.26q12.51,0,19.92,7.92,7.1,7.62,7.09,19.71T287.36,82.6q-7.41,7.94-19.92,7.93T247.52,82.6q-7.1-7.6-7.09-19.71T247.68,43Q254.91,35.26,267.44,35.26Zm0,11.68a12.17,12.17,0,0,0-10.22,4.9,19.48,19.48,0,0,0,0,22.11,13.11,13.11,0,0,0,20.44,0,19.48,19.48,0,0,0,0-22.11A12.17,12.17,0,0,0,267.44,46.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349.6,50.27l-11.16,5.11a12.17,12.17,0,0,0-4.33-6.15,11.15,11.15,0,0,0-6.83-2.29,12.17,12.17,0,0,0-10.22,4.9,17.63,17.63,0,0,0-3.44,11,18.54,18.54,0,0,0,3.13,11.06,11.42,11.42,0,0,0,9.8,4.9q8.65,0,12.83-10.22l10.84,5.73q-7.41,16.17-23.88,16.17-11.88,0-19.08-7.93-7-7.6-7-19.71T307.51,43q7.24-7.77,19.76-7.77Q343.44,35.26,349.6,50.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402,52.57V80.41c0,3.83.66,6.78,2,8.87H390.44a8.51,8.51,0,0,1-1.25-4.8A26.66,26.66,0,0,1,372,90.53,18.59,18.59,0,0,1,359.16,86,15.3,15.3,0,0,1,354,74q0-13.35,16.06-16.48l5.32-1q5.31-1,13.76-3.13V51.81q0-6.66-10-6.67c-3.68,0-6.24.59-7.66,1.77s-2.14,3.24-2.14,6.16l-12.72-.53q0-8.66,6.88-13.24,6-4,15.64-4,10.32,0,15.64,3Q402,42.35,402,52.57ZM389.22,70.4V62.89a26,26,0,0,1-6,1.88l-7,1.46a18.11,18.11,0,0,0-6.16,2.19,5.66,5.66,0,0,0-2.6,5.11,5.72,5.72,0,0,0,2.34,4.74,9.31,9.31,0,0,0,5.9,1.83,17.19,17.19,0,0,0,9-2.29Q389.22,75.1,389.22,70.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M461.07,36.51V89.28H448.35V84.06q-5,6.47-15.21,6.47-8.19,0-13.12-3.76-6.29-4.89-6.29-15.33V36.51h12.71V67.79q0,10.44,9.39,10.43,6.57,0,9.9-4.27a14.93,14.93,0,0,0,2.61-9.08V36.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M466.81,89.28l18.25-28.47-15.85-24.3H484l8.43,12.93,8.45-12.93H515.7l-15.85,24.3L518.1,89.28H502.89L492.44,72.59,482,89.28Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocauxExtendWhite);
export default __webpack_public_path__ + "static/media/geolocaux-extend-white.fb9ccb26.svg";
export { ForwardRef as ReactComponent };